import React from "react";
import { useInView } from '../hooks/useInView';
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  const { ref, inView } = useInView({ threshold: 0.1 });
  
  return (
    <div ref={ref} className={`section-fade ${inView ? 'in-view' : ''}`} id="history">
      <div className="items-container">
        <h1>Career & Education</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="24th Jun 2025 - 24th Dec 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Development Engineer (SDE) Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">MS RiskTec</h4>
            <p>
              Worked on end-to-end development of AI-driven solutions for banking and insurance domains. Developed fraud detection systems, early warning risk detection models, personalized product recommendation engines, and AI-powered chatbot systems. Built data pipelines, dashboards, and analytics workflows for actionable business insights.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="28th May 2025 - 4th July 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Backend Development Intern (Python)</h3>
            <h4 className="vertical-timeline-element-subtitle">Code Grills - Remote</h4>
            <p>
              Designed and developed scalable backend systems using Flask and MongoDB. Implemented CI/CD pipelines, automated testing workflows, and optimized backend APIs for performance and reliability.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Feb 2025 - Apr 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Web Development Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Innobyte Services - Remote</h4>
            <p>
              Developed responsive and secure web applications with improved performance. Integrated Google reCAPTCHA v3 to enhance application security and improved UI/UX design with cross-browser compatibility.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2025 - Apr 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Blockchain Developer - Google Solution Challenge 2025</h3>
            <h4 className="vertical-timeline-element-subtitle">GDG Kolkata (Top 105 Teams)</h4>
            <p>
              Developed a decentralized blockchain-based voting system using Solidity and React.js. Integrated IPFS and MetaMask for secure, transparent elections with voter verification and tamper-proof result aggregation.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="Sep 2023 - Jun 2027"
            iconStyle={{ background: '#e91e63', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">B.Tech in Computer Science & Engineering</h3>
            <h4 className="vertical-timeline-element-subtitle">B.P. Poddar Institute of Management and Technology, Kolkata</h4>
            <p>
              CGPA: 9.24 | Focused on AI/ML, Full Stack Development, and Software Engineering
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="2023"
            iconStyle={{ background: '#e91e63', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGraduationCap} />}
          >
            <h3 className="vertical-timeline-element-title">ISC (Class XII)</h3>
            <h4 className="vertical-timeline-element-subtitle">St. Augustine's Day School, Barrackpore, Kolkata</h4>
            <p>
              90.75%
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;